import { Store } from "vuex";

import RootStore from "../root-state";

export type StoreHook = (vuexStore: Store<RootStore>) => void;

// All hooks that are added here get executed
const HOOKS: StoreHook[] = [];
export default HOOKS;
